import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";
import ResumoPage from "./pages/resumo";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
  resumo: ResumoPage,
};

const SorteioPageController = () => {
  //estados globais
  const sorteioState = useAppSelector((state) => state.sorteio);

  const Page = pages[sorteioState.page];

  return <Page key={sorteioState.page} />;
};

export default SorteioPageController;
